import store from "@/store"
import firebase from "firebase"
export default {
	userId(){
		return firebase.auth().currentUser.uid;
	},
	checkAuth(){
		return new Promise((resolve) => {
			var auth = store.getters.getAuth;
			if(!auth.logged_in){
				store.dispatch("auth/checkAuth").then( () => {
					resolve( auth )
				}).catch( () => {
					resolve( {} )
				})
			}
			else{
				resolve( auth );	
			}

		})
	},
	getUserRole(){
		return new Promise((resolve) => {
			var user = store.getters.getUser;
			if( user.role ){
				resolve( user.role )
			}
			else{				
				store.dispatch("user/getUserRole").then( role => {
					resolve(role)
				})
			}
		})
	}

} 